export enum IEventStatus {
    UNKNOWN = "0",
    NEW = "1",
    PENDING = "2",
    FAILED = "3",
    SUCCESS = "4",
    RESOLVED = "5"
}
